import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import DatasetDateFilterStep1Adapter from './dataset-date-filter-step1-adapter'

const DateFilterStep1 = DatasetDateFilterStep1Adapter.extend({

	tagName: 'form',

	initialize: function(options = {}) {
		let fvConstructor = FormView.extend({test: this.test.bind(this)})
		this.formView = new fvConstructor({
			el: this.el,
			guard: false,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
		options.formView = this.formView
		DatasetDateFilterStep1Adapter.prototype.initialize.apply(this, arguments)
	},

	render: function () {
		DatasetDateFilterStep1Adapter.prototype.render.apply(this, arguments)
		this.options.wizard.render({
			formView: this.formView
		})
		this.formView.start()
		return this
	},

	submit: function() {
		this.trigger('next',this.gather())
	},

	remove: function() {
		DatasetDateFilterStep1Adapter.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView], 'remove')
	}

})

export default DateFilterStep1

DateFilterStep1.__filename__ = 'reports/common/filter/date-filter-step1.js'
